import { SchedulingTypes } from "./schedulingTypes";

export const initialState: SchedulingTypes = {
    fetching: false,
    schedulingUserViewListing:[],
    message:null,
    error: null,
    success: null,
    statusCode:null,
    userViewListTotal:0,
    employeeApprovedList:[],
    employeeAprrovedTotalCount:0,
    previousHours:0,
    commentList:[],
    commentFetching:false,
    commentListTotalCount:0,
    managerNewRequestCount: 0,
    requestView:{},
    schedulingManagerViewNewRequestsListing:[],
    reEstimateDataList:[],
    reEstimateDataTotalCount:0,
    calendarData:[],
    dailyHours:{},
    allusersScheduleList:[],
    allusersScheduleTotalCount:0,
    allClientScheduleList:[],
    allClientScheduleTotalCount:0,
    clientUserSchedulingList:[],
    clientUserSchedulingListTotal:0,
    clientJobSchedulingList:[],
    clientJobSchedulingTotal:0,
    singleJobScheduledHoursSum:0,
    singleJobScheduledHoursList:[],
    singleJobScheduledHoursListCount:0,
    allUserMappedToJob:[],
    usersAvailabilityReportData:[],
    usersAvailabilityTotalCount:0,
    daysTotal:[],
}

  
